import { useCallback, useEffect, useMemo, useState } from "react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbar,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import BookIcon from "@mui/icons-material/Book";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

import formatDateTime, {
  formatDateNaissance,
} from "../../../utils/dateFormate";
import { AssureService } from "../../../services/assuranceService";
import RegisterAssure from "../modals/RegisterAssure";
import { appColors } from "../../../constant/constant";
import ProfilAssureModal from "../modals/profilAssureModal";
import UpdateAssureModal from "../modals/UpdateAssureModal";
import ChangePoliceModal from "../modals/changePoliceModal";
import DesactiveAssureModal from "../modals/DesactiveAssureModal";
import { API } from "../../../api/API";
import RegisterPersonnel from "../modals/RegisterPersonnel";
import ProfilPersonnelModal from "../modals/profilPersonnel";
import UpdatePersonnelModal from "../modals/UpdatePersonnel";
import DeleteDialog from "../modals/DeleteModal";
import DeactivateDialog from "../modals/Deactivate";

// Composant pour la barre d'outils avec un bouton "Ajouter un stagiaire"

// Toolbar component with additional button

const actionTypes = {
  voir: "Voir",
  modifier: "Modifier",
  desactive: "Activate/Desactive",
  delete: "Delete",
};
const iconList = [
  <VisibilityOutlinedIcon sx={{ color: appColors.secondary }} />,
  <TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,
  <BookIcon sx={{ color: appColors.warning }} />,

  /*  <TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,*/
  <DeleteOutlineOutlinedIcon sx={{ color: appColors.danger }} />,
];
const DataGridPersonnel = () => {
  const [isLoading, setisLoading] = useState(true);
  const [selectedRow, setselectedRow] = useState(null);
  const [pagination, setpagination] = useState({ page: 1, limit: 50 });
  const [showModal, setShowPersonnelModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [shwoDesactivate, setShowDesactivate] = useState(false);
  const [rows, setRows] = useState([]);

  const handleAction = useCallback((row, actionType) => {
    //row is the row data
    setselectedRow(row);
    switch (actionType) {
      case actionTypes.voir:
        setShowPersonnelModal(true);
        break;
      case actionTypes.modifier:
        setShowUpdateModal(true);
        break;
      case actionTypes.desactive:
        setShowDesactivate(true);
        break;
      case actionTypes.delete:
        setShowDelete(true);
        break;
      default:
        break;
    }
  }, []);

  /**handleDelete item */
  const handleDeleteConfirm = async () => {
    if (!selectedRow) return;
    try {
      const res = await API.delete(`/assurance/agents/${selectedRow.id}`);
      if (res.status === 200 || res.status === 204) {
        handleRefresh();
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleDeactivate = async () => {
    if (!selectedRow) return;
    try {
      const response = await API.patch(
        `/assurance/agents/deactivate/${selectedRow.id}`
      );
      if (response.status === 200 || response.status === 204) {
        handleRefresh();
      } else {
        console.error("Failed to deactivate personnel:", response.statusText);
      }
    } catch (error) {
      console.error(
        "Error during deactivation:",
        error.response?.data || error.message
      );
    }
  };
  const columns = useMemo(
    () => [
      {
        field: "order",
        headerName: "#",
        width: 80,
      },
      {
        field: "full_name",
        headerName: "Nom Complet",
        width: 160,
      },
      {
        field: "tel",
        headerName: "Téléphone",
        width: 140,
      },
      {
        field: "email",
        headerName: "Email",
        width: 200,
      },
      {
        field: "role",
        headerName: "Rôle",
        width: 140,
      },
      {
        field: "statut",
        headerName: "Statut",
        type: "boolean",
        width: 100,
        renderCell: (params) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: params.value ? appColors.success : appColors.warning,
            }}
          >
            {params.value ? "Actif" : "Inactif"}
          </Box>
        ),
      },
      {
        field: "createdAt",
        headerName: "Créé le",
        valueGetter: (value, row) => formatDateTime(value),
        width: 160,
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 80,
        disableExport: true,
        getActions: (params) =>
          Object.entries(actionTypes).map((i, index) => {
            return (
              <GridActionsCellItem
                icon={iconList[index]}
                label={`${i[1]}`}
                key={i[0]}
                onClick={() => handleAction(params.row, i[1])}
                showInMenu
              />
            );
          }),
      },
    ],
    [handleAction]
  );

  useEffect(() => {
    //fetch data from api
    getPersonnels();
  }, []);
  // Fonction de rafraîchissement des données
  const handleRefresh = () => {
    setisLoading(true);
    getPersonnels();
  };

  //get stagiaire function from api
  const getPersonnels = async () => {
    try {
      const response = await API.get(`assurance/agents`);
      if (response.status === 200) {
        const { data } = response.data;
        const _data = data.map((row, index) => ({
          ...row,
          order: index + 1, // Ajouter le numéro d'ordre
        }));
        setRows(_data);
      }
    } catch (error) {
      console.error("Failed to fetch stagiaires:", error);
    } finally {
      setisLoading(false);
    }
  };
  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ backgroundColor: "#f5f5f5", color: "#37B049" }}>
      <GridToolbar
        sx={{
          "& .MuiButton-root": {
            color: "#37B049",
          },
          "& .MuiSvgIcon-root": {
            color: "#37B049",
          },
        }}
      />
      <RegisterPersonnel onRefresh={handleRefresh} />
    </GridToolbarContainer>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        slots={{
          toolbar: () => <CustomToolbar />,
        }}
        columns={columns}
        rows={rows}
        checkboxSelection
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pagination.limit,
            },
          },
        }}
        pageSizeOptions={[pagination.limit]}
        loading={isLoading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
      />
      {/** liste des modal */}
      <ProfilPersonnelModal
        show={showModal}
        handleClose={() => setShowPersonnelModal(false)}
        personnel={selectedRow}
      />
      <UpdatePersonnelModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        personnel={selectedRow}
        onUpdateSuccess={handleRefresh}
      />
      <DeleteDialog
        isDeleteDialogOpen={showDelete}
        setIsDeleteDialogOpen={() => setShowDelete(false)}
        handleDeleteConfirm={handleDeleteConfirm}
      />
      <DeactivateDialog
        isDeactivateDialogOpen={shwoDesactivate}
        setIsDeactivateDialogOpen={() => setShowDesactivate(false)}
        handleDeactivateConfirm={handleDeactivate}
      />
    </Box>
  );
};

export default DataGridPersonnel;
